import { render, staticRenderFns } from "./CityPage.vue?vue&type=template&id=474089bc&"
import script from "./CityPage.vue?vue&type=script&lang=js&"
export * from "./CityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports